<template>
  <header>
    <div class="header">
      <div class="inner">
        <a class="logo" href="/">
          <!-- <img alt="CT Butterfield" src="../assets/butterfields.png"> -->
          <img alt="CT Butterfield" src="../assets/butterfields-150.jpg">
        </a>
        <!-- <div class="strapline">
          <strong>Family funeral directors</strong> with one standard of excellence
          <strong>since 1874</strong>
        </div> -->
        <div style="margin-left:auto">
          <img class="reviews" src="../assets/google-reviews.jpg" alt="Google 5 Star Reviews" />
          <div class="social">
            <a aria-label="Facebook" href="https://www.facebook.com/Butterfields-415113525348535/" rel="noreferrer"
              target="_blank">
              <i class="fa fa-facebook-square"></i>
            </a>
            <a aria-label="Instagram" href="https://www.instagram.com/butterfieldmonumentalmasons/" rel="noreferrer"
              target="_blank">
              <i class="fa fa-instagram"></i>
            </a>
          </div>
          <div class="telephones">
            <div :key="branch._id" class="office" v-for="branch in settings.branches">
              <i class="fa fa-phone"></i>
              <div>
                <span class="location">{{ branch.name }}</span>
                <a :href="'tel:' + removeSpaces(branch.telephone)">{{ branch.telephone }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import stringutil from "@/utils/formatstring"

export default {
  name: "PageHeader",
  props: ["settings"],
  mixins: [stringutil]
}
</script>

<style scoped>
.inner {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 94%;
  max-width: 1400px;
  margin: auto;
}

header {
  position: relative;
  z-index: 3;
  background: white;
}


/* .header {
  padding: 3rem 0;
} */

.social {
  float: right;
  font-size: 3.5rem;
  padding-top: 2.1rem;
  color: #90a3a3;
  margin-left: 1.5rem;
}

.social i {
  margin-left: 1.5rem;
}

.logo {
  width: 50rem;
  display: block;
  float: left;
}

.strapline {
  font-family: "Roboto Slab", Georgia, "Times New Roman", Times, serif;
  float: left;
  font-size: 2rem;
  width: 40rem;
  margin-left: 3rem;
  border-left: 0.3rem solid #b1ba22;
  padding-left: 2rem;
  color: #90a3a3;
  position: relative;
  top: 1.5rem;
}

.telephones {
  float: right;
}

.office {
  display: inline-block;
  margin-left: 3rem;
  margin-top: 2rem;
}

.office>i {
  display: inline-block;
  font-size: 3rem;
  margin-right: 1rem;
  color: #90a3a3;
}

.office>div {
  display: inline-block;
}

.office>div>* {
  display: block;
  white-space: nowrap;
}

.office span {
  font-size: 1.3rem;
  color: #90a3a3;
}

.office a {
  color: #b1ba22;
  font-size: 2rem;
}

.reviews {
  float: right;
  height: 5rem;
  margin-left: 5rem;
  position: relative;
  bottom: -1.2rem
}

@media screen and (max-width: 1600px) {
  .reviews {
    height: 4rem;
    margin-left: 3rem;
    bottom: -1.9rem
  }

  .strapline {
    font-size: 1.8rem;
    width: 32rem;
  }

  .office {
    margin-top: 2.3rem
  }

  .office a {
    font-size: 1.8rem;
  }
}

@media screen and (max-width: 1200px) {
  .reviews {
    height: 4rem;
    margin-left: 3rem;
    bottom: -1.9rem
  }
}

@media screen and (max-width: 1060px) {
  .telephones {
    display: none;
  }
}

@media screen and (max-width: 650px) {

  .social,
  .reviews {
    display: none;
  }

  .header {
    text-align: center;
  }

  .logo,
  .strapline {
    display: inline-block;
    float: none;
  }

  .strapline {
    padding-left: 0rem;
    top: -0.5rem;
    width: 35rem;
  }
}

@media screen and (max-width: 500px) {
  .strapline {
    display: none;
  }

  .header {
    padding: 1.5rem;
  }
}
</style>
